module.exports = __webpack_public_path__ + "img/IDP小助手.f89696ad.png";